import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import MDIcon from '../../../shared/components/MDIcon';

const FunctionalityItemLink = ({ title, to, icon }) => (
  <NavLink to={to}>
    <li className="functionality__link">
      {icon ? <MDIcon iconPath={icon} /> : null}
      <span>{title}</span>
    </li>
  </NavLink>
);

FunctionalityItemLink.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

FunctionalityItemLink.defaultProps = {
  icon: null,
};

export default FunctionalityItemLink;
